import React from 'react';

import RoomCountText from './component';

export default React.memo(RoomCountText);
